// src/lib/supabase.ts - Enhanced with proper session management
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        // Enable automatic session refresh
        autoRefreshToken: true,
        // Persist session in localStorage
        persistSession: true,
        // Enable session detection across tabs
        detectSessionInUrl: true,
    },
})

// Automatic session management handled by Supabase client
// (autoRefreshToken and detectSessionInUrl are enabled)

// Debug function for development
export const debugAuth = async (): Promise<void> => {
    if (import.meta.env.DEV) {
        console.log('=== 🔍 AUTH DEBUG ===');
        const { data: { session }, error } = await supabase.auth.getSession();
        console.log('Current session:', session);
        console.log('Session error:', error);
        console.log('User:', session?.user);
        console.log('Access token expires at:', session?.expires_at ? new Date(session.expires_at * 1000) : 'N/A');
        console.log('LocalStorage auth key:', Object.keys(localStorage).filter(key => key.includes('supabase')));
        console.log('========================');
    }
};

// Make debug available in development
if (import.meta.env.DEV) {
    (window as any).debugAuth = debugAuth;
    // Auto-debug on auth state changes in development
    supabase.auth.onAuthStateChange((event, session) => {
        console.log(`🔔 [DEBUG] Auth event: ${event}`, session ? 'Session exists' : 'No session');
    });
}
